import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-dashcam-installation-video',
    imports: [],
    templateUrl: './dashcam-installation-video.component.html',
    styleUrl: './dashcam-installation-video.component.scss'
})
export class DashcamInstallationVideo implements OnInit {

    constructor() {

    }

    ngOnInit() {

    }
}